import { render, staticRenderFns } from "./DeliveryLimitWarning.vue?vue&type=template&id=0d2eea10"
import script from "./DeliveryLimitWarning.vue?vue&type=script&lang=js"
export * from "./DeliveryLimitWarning.vue?vue&type=script&lang=js"
import style0 from "./DeliveryLimitWarning.vue?vue&type=style&index=0&id=0d2eea10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports